/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetLedgerModuleByAssetOptions,
  GetLedgerModuleByAssetResponses,
} from '../types/GetLedgerModuleByAsset'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get the module object for a single asset ID
 * {@link /v1/ledger/module/:asset_id}
 */
export function getLedgerModuleByAsset<ThrowOnError extends boolean = true>(
  options: Options<GetLedgerModuleByAssetOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetLedgerModuleByAssetResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/ledger/module/{asset_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetLedgerModuleByAssetResponses, ThrowOnError>>,
  )
}
